import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseByMonthDatatable";

import {
  getSingleMonthlyExpenseRedux,
  getSingleMonthlyCashInRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import "./monthlyexpenseByMonth.css";
import "./monthlyexpense.css";
import "../../1688-taobao-orders/invoice-by-order.css";
import logo from "../../../assets/images/brand/kido-logo.png";
import { BRAND } from "../../../constants/brand";
export class MonthlyExpenseByMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
      filterCategoryCashIn: "",
      filterCategoryCashOut: "",
    };
  }

  componentDidMount = async () => {
    const [type, month] = this.props.match.params.month.split("-");
    if (type === "expense") {
      this.props.getSingleMonthlyExpenseRedux(month);
    } else {
      this.props.getSingleMonthlyCashInRedux(month);
    }
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { open } = this.state;
    const [type, month] = this.props.match.params.month.split("-");
    console.log(this.props);
    let totalCashIns = 0;
    let totalCashOuts = 0;
    let renderableExpense = this.props.allExpenses;
    if (this.state.filterCategoryCashOut) {
      renderableExpense = this.props.allExpenses.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashOut.toLowerCase()
      );
    }
    renderableExpense.map((expense) => {
      totalCashOuts += parseInt(expense.amount);
    });

    let renderableCashIn = this.props.allCashIns;
    if (this.state.filterCategoryCashIn) {
      renderableCashIn = this.props.allCashIns.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashIn.toLowerCase()
      );
    }
    renderableCashIn.map((cashIn) => {
      totalCashIns += parseInt(cashIn.amount);
    });

    let data = [];
    if (type === "expense") {
      data = renderableExpense;
    } else {
      data = renderableCashIn;
    }

    return (
      <Fragment>
        <Breadcrumb
          title={type === "expense" ? "Cash Out" : "Cash In"}
          parent="Cash history"
        />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid mh-page kd-cash kd-st--sky">
          <div className="row">
            <div className="col-sm-12">
              <div className="card mh-card">
                <div
                  className="card-header mh-card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 10,
                  }}
                >
                  <h5 className="mh-card-title">
                    <i className="icofont-calendar mh-card-icon"></i>
                    {month}
                  </h5>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <ReactToPrint
                      trigger={() => (
                        <button className="btn mh-print-btn">
                          Monthly Statement
                        </button>
                      )}
                      content={() => this.componentRef}
                    />

                    {type === "expense" ? (
                      <select
                        title="Filter by category"
                        required
                        name="filterCategoryCashOut"
                        className="custom-select mh-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.filterCategoryCashOut}
                      >
                        <option value="">Filter by category </option>
                        <option value="">All</option>
                        <option value="DAILY COST">DAILY COST</option>
                        <option value="OFFICE">OFFICE</option>
                        <option value="SALARY">SALARY</option>
                        <option value="LOAN">LOAN</option>
                        <option value="SHIPPING">SHIPPING</option>
                        <option value="Boosting">BOOSTING/PROMOTION</option>
                        <option value="REFUND">REFUND</option>
                        <option value="TRANSPORT">TRANSPORT</option>
                        <option value="BUY PRODUCTS">BUY PRODUCTS</option>
                      </select>
                    ) : (
                      <select
                        title="Filter by category"
                        required
                        name="filterCategoryCashIn"
                        className="custom-select mh-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.filterCategoryCashIn}
                      >
                        <option value="">Filter by category </option>
                        <option value="">All </option>
                        <option value="LOAN">LOAN</option>
                        <option value="OTHERS">OTHERS</option>
                        <option value="ORDERS">ORDERS</option>
                      </select>
                    )}
                  </div>
                </div>
                <div className="card-body">
                  <div className="mh-total-chip">
                    <span className="mh-total-chip-label mh-stamp-font">
                      {type === "expense" ? "Cash Out Total" : "Cash In Total"}
                    </span>
                    <span className="mh-total-chip-value">
                      {type == "expense" ? totalCashOuts : totalCashIns}Tk
                    </span>
                  </div>
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <div className="print-table-wrapper">
                      <Datatable
                        startToggleModal={this.startToggleModal}
                        history={this.props.history}
                        multiSelectOption={false}
                        myData={
                          type === "expense"
                            ? renderableExpense
                            : renderableCashIn
                        }
                        pageSize={50}
                        pagination={true}
                        class="-striped -highlight"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
        <div style={{ display: "none" }}>
          <div ref={(el) => (this.componentRef = el)} className="print-area">
            {/* Same KIDO design as the order invoice (invoice-by-order.css). */}
            <div className="zp-inv-card zp-inv-card--statement">
              <div className="zp-inv-accent" />

              <header className="zp-inv-header">
                <div>
                  <div className="zp-inv-brand">
                    <img src={logo} alt="KIDO" />
                  </div>
                  <div className="zp-inv-company-info">
                    {/* TODO: KIDO's address once the client provides it */}
                    <div>📞 ফোন: {BRAND.phone}</div>
                    <div>{BRAND.email}</div>
                  </div>
                </div>
                <div className="zp-inv-title-block">
                  <div className="zp-inv-title">Monthly statement</div>
                  <div className="zp-inv-number">{String(month || "").replace(",", " ")}</div>
                </div>
              </header>

              <div className="zp-inv-meta">
                <div>
                  <div className="zp-inv-meta-label">Statement</div>
                  <div className="zp-inv-detail-row">
                    <span className="k">Type</span>
                    <span className="v">{type === "expense" ? "Cash out" : "Cash in"}</span>
                  </div>
                  <div className="zp-inv-detail-row">
                    <span className="k">Created</span>
                    <span className="v">
                      {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}
                    </span>
                  </div>
                  <div className="zp-inv-detail-row">
                    <span className="k">Entries</span>
                    <span className="v">{data.length}</span>
                  </div>
                </div>
                <div>
                  <div className="zp-inv-meta-label">Summary</div>
                  <div className="zp-inv-summary-row zp-inv-summary-row--due">
                    <span className="k">
                      {type === "expense" ? "Cash out" : "Cash in"} total
                    </span>
                    <span className="v">
                      {type == "expense" ? totalCashOuts : totalCashIns}Tk
                    </span>
                  </div>
                </div>
              </div>

              <div className="zp-inv-section">
                <table className="zp-inv-payments-table zp-inv-statement-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Category</th>
                      <th>Sub category</th>
                      <th>Note</th>
                      <th className="is-num">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.date}</td>
                        <td>{item.category}</td>
                        <td>{String(item.subCategory || "").replace(/^undefined-/, "")}</td>
                        <td>{item.note}</td>
                        <td className="is-num">{item.amount}Tk</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="zp-inv-footer">
                <div />
                <div className="zp-inv-thanks">KIDO</div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpenses: state.expenses.singleMonthExpense,
    allCashIns: state.cashIns.singleMonthCashIn,
  };
};

export default connect(mapStateToProps, {
  getSingleMonthlyExpenseRedux,
  getSingleMonthlyCashInRedux,
})(MonthlyExpenseByMonth);
